import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'cb0037',
    ecrans: ['00-2'],
    params: ['id',
            '?el1cleint',
            '?prucleint',
            '?vaesysnatctb',
            '?peccleintdeb',
            '?peccleintfin',
            '?indcleint']
});
